import PLAN_REFERENCE_DATA from '../../assets/cq/productreference.model.json'; // Fall back When getPlanReferenceData fails
import { HttpService } from '../../services/HttpService';
import { store } from '../../configureStore';
import * as constants from './constants';
import { apiUrls } from '../../constants/apiUrl';
import { getSecureBaseUrl } from '../../services/UrlMapperService';

const PlanRefData = PLAN_REFERENCE_DATA;

export const getProductRefData = (sorId, planId, planRefData) => {
  const plansInfo = [];
  if (!sorId && !planId) return null;
  if (planRefData) {
    Object.keys(planRefData).forEach((id) => {
      if (sorId === id) {
        plansInfo.push(planRefData[id]);
      } else if (planId === id) {
        plansInfo.push(planRefData[id]);
      }
    });
  }
  return plansInfo;
};

export async function fetchPlansData() {
  try {
    const apiURL =
      window.location.hostname === 'localhost' ? `${getSecureBaseUrl()}${apiUrls().getProductReferenceurl}` : apiUrls().getProductReferenceurl;

    const response = await HttpService.get(apiURL);
    if (response && response.data && response.status === 200) {
      return response.data;
    }
    return PlanRefData;
  } catch (error) {
    console.error(error);
    return PlanRefData;
  }
}

export const checkPlanReferenceData = (planReferenceData) => {
  if (!planReferenceData || Object.keys(planReferenceData).length === 0) {
    // fetchPlansData();

    fetchPlansData()
      .then((res) => {
        if (res) {
          store.dispatch({ type: constants.UPDATE_PLANS_DATA, response: res });
        } else {
          store.dispatch({ type: constants.UPDATE_PLANS_DATA, response: PlanRefData });
        }
      })
      .catch((error) => {
        console.log('error on fetchPlansData', error);
      });
  }

  return planReferenceData;
};

export const getPlanReferenceData = () => store.getState().plansReferenceData.output;

export const getPlansData = (prodRefData) => (prodRefData && prodRefData.output) || {};
